import React from 'react';
import * as C from '../common-styles.styles';
import * as S from './faqs.styles';

const FAQ = props => {
  const { faqs, isDweb, sector } = props;
  return (
    <C.Wrap isDweb={isDweb}>
      <S.FAQWrapper>
        <span itemScope itemType="https://schema.org/FAQPage">
          <h2>Frequently Asked Questions - {sector}</h2>
          {faqs.map((faq, i) => (
            <span
              itemScope
              itemProp="mainEntity"
              itemType="https://schema.org/Question"
              key={`faq${i}`}
            >
              <S.QnAWrapper>
                <S.QuestionWrapper>
                  <p itemProp="name">
                    <strong>Q: {faq.q}</strong>
                  </p>
                </S.QuestionWrapper>
                <span itemScope itemProp="acceptedAnswer" itemType="https://schema.org/Answer">
                  <S.AnswerWrapper>
                    <p itemProp="text">A: {faq.a}</p>
                  </S.AnswerWrapper>
                </span>
              </S.QnAWrapper>
            </span>
          ))}
        </span>
      </S.FAQWrapper>
    </C.Wrap>
  );
};

export default FAQ;
